module.exports = __webpack_public_path__ + "img/12.e048f1c3.jpg";